const Card = props => (
  <svg viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Card</title>
    <path d="M7 15h3a1 1 0 100-2H7a1 1 0 100 2zM19 5H5a3 3 0 00-3 3v9a3 3 0 003 3h14a3 3 0 003-3V8a3 3 0 00-3-3zm1 12a1 1 0 01-1 1H5a1 1 0 01-1-1v-6h16v6zm0-8H4V8a1 1 0 011-1h14a1 1 0 011 1v1z" />
  </svg>
);

export { Card };
